import { render } from "./SeparationFNF.vue?vue&type=template&id=3125404e&scoped=true"
import script from "./SeparationFNF.vue?vue&type=script&lang=js"
export * from "./SeparationFNF.vue?vue&type=script&lang=js"

import "./SeparationFNF.vue?vue&type=style&index=0&id=3125404e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3125404e"]])

export default __exports__